// Popula a seção
function populateBlog($parent, section, action = 'insert') {
  if ($parent.length > 0 && section) {
    // Atualiza a seção (Remove antes para ser criada novamente)
    if (action === 'update') {
      const $sectionUpd = $('#' + section.id);
      if ($sectionUpd.length > 0) {
        $sectionUpd.html('');
        $sectionUpd.remove();
      }
    }

    // Exibe seção
    const showSection = section['show'];
    const showSectionClass = !showSection ? 'd-none' : '';

    // Alinhamento do titulo
    const titAlignClass = section['tit-align'] == 'center' ? 'center' : '';

    // Itens
    let itensHTML = `<div class="carousel carousel-arrows-circle carousel-infinite-mb carousel-blog" data-aos="fade-up" data-aos-offset="0">`;
    let $itens = $(itensHTML);
    if (postsHome && postsHome.length > 0) {
      postsHome.forEach((post) => {
        // Categorias
        const $postCats = '';
        if (post.categories && post.categories.length > 0) {
          for (let i = 0; i < post.categories; i++) {
            $postCats = +`<span class="badge post-cat">${post.categories[i].title}</span>`;
          }
        }
        // HTML do bloco
        let itemHTML = `
        <a href="${urlBase}post/${post.seo_url}" class="carousel-item post-wrp">
          <div class="post link-arrow-hv">
            <figure class="img post-img">
              <img src="${post['thumb-400-300']}" alt="${post.title}">
              <div class="post-cats">
                ${$postCats}
              </div>
            </figure>
            <div class="post-infos">
              <div class="post-date">${formataDataExt(post.date_show, '{F} {Y}')}</div>
              <div class="post-title">${post.title}</div>
              <div class="post-text">${post.description}</div>
              <div class="post-link">
                <div class="link-arrow">Ver postagem ${getSvgIcon('arrow-right')}</div>  
              </div>
            </div>
          </div>
        </a>`;
        const $item = $(itemHTML);
        $itens.append($item);
      });
    }

    // Link "Ver todos"
    let linkViewAll = '';
    if (section['show-link'] == '1') {
      linkViewAll = `<a href="${urlBase}blog" class="link link-arrow">Ver todos ${getSvgIcon('arrow-right')}</a>`;
    }

    // Estrutura da seção
    let sectionHTML = `
    <section id="${section['id']}" data-sec-type="blog" class="home-section home-blog bg-image ${showSectionClass}">
      <div class="carousel-sec-top">
        <div class="container">
          <div class="row catalogo-titulo-wrp" data-aos="fade-up" data-aos-offset="0">
            <div class="grid-12 catalogo-titulo-content ${titAlignClass}">
              <h2 class="title home-title md-text">${section['titulo']}</h2>
              ${linkViewAll}
            </div>
          </div>
        </div>
      </div>
      <div class="carousel-sec-content">
        <div class="container">
          ${$itens[0].outerHTML}
        </div>
      </div>
      <div class="carousel-sec-bottom">
        <div class="container">
          <div class="row">
            <div class="grid-12"></div>
          </div>
        </div>
      </div>
    </section>`;

    // Cria o elemento
    let $section = $(sectionHTML);

    // Estilos
    if (Object.keys(section.styles).length > 0) {
      Object.keys(section.styles).forEach((styleVar) => {
        $section[0].style.setProperty('--' + styleVar, section.styles[styleVar]);
      });
    }

    // Ordem da seção
    $section[0].style.setProperty('--order', section['order']);
    $section[0].style.setProperty('order', section['order']);

    // Plano de fundo (Imagem)
    if (section['bg-type'] == 'image') {
      $section[0].style.setProperty('background-image', `url('${section['bg-image']}')`);
    }
    // Plano de fundo (Gradiente)
    else if (section['bg-type'] == 'gradient') {
      $section[0].style.setProperty('background-image', section['bg-gradient']);
    }

    $parent.append($section);

    // Plugins
    setTimeout(() => {
      blogDestroySlick();
      blogInitSlick();
    }, 100);
  }
}
